export default class {

    constructor() {
        this.market_store = 'm1010store';
        // this.business_store = 'm1010store';
       
    }

    setMarketStoreForage(data){
        localforage.setItem(this.market_store, data).then(function (value) {
           // Do other things once the value has been saved.
          //console.log(value);
        }).catch(function(err) {
            // This code runs if there were any errors
            // console.log(err);
        });
            
    }
    
    setBusinessStoreForage(data){
        localforage.setItem(this.business_store, data).then(function (value) {
           // Do other things once the value has been saved.
          //console.log(value);
        }).catch(function(err) {
            // This code runs if there were any errors
            // console.log(err);
        });
            
    }
    getBusinessStoreForage(){
        
    }
}


// WEBPACK FOOTER //
// ./src/services/utility.js